// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Migration_PreflightClientesInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract de GET /migration/clientes/preflight?zoho_id_unidade=...
 * (controllers/migration/clientes.php::preflight).
 *
 * A franquia e OBRIGATORIA: a carga de clientes e por franquia (o export e
 * paginado por cursor porque ate por franquia o lote inteiro estoura o
 * limite do Creator — 9430; Saguacu tem 5.034 clientes).
 */
import { registerContract } from './validate'

export interface Migration_PreflightClientesInput {
zoho_id_unidade?: string
data_ini?: string
data_fim?: string
ids?: string
}

registerContract('Migration_PreflightClientesInput', {
  zoho_id_unidade: { type: 'string',  required: false },
  data_ini:        { type: 'string',  required: false },
  data_fim:        { type: 'string',  required: false },
  ids:             { type: 'string',  required: false },
})
